export default {
  all: [],
  one: null,
};
